module.exports = __webpack_public_path__ + "img/banner2.8ec71c8f.jpg";